// import React, { useState, useEffect } from 'react';
// import { Plus, X, ArrowUpDown, Download, Upload, Eye, Edit2, Trash2, Settings, Columns, Check } from 'lucide-react';
// import { candidatesAPI, jobsAPI } from "../../services/api";
// import { toast } from "react-toastify";
// import { exportCandidatesToExcel } from "../../utils/ExportUtils";
// import Delete from "../common/Delete";
// import CreateCandidateModal from "./CreateCandidateModal";
// import EditCandidateModal from "./EditCandidateModal";
// import CandidatePreview from "./CandidatePreview";
// import ImportCandidatesModal from "./ImportCandidatesModal";
// import FixCandidateFieldsModal from "./FixCandidateFieldsModal";

// const Candidates = () => {
//   const [candidates, setCandidates] = useState([]);
//   const [filteredCandidates, setFilteredCandidates] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showPreviewModal, setShowPreviewModal] = useState(false);
//   const [showImportModal, setShowImportModal] = useState(false);
//   // const [showShareModal, setShowShareModal] = useState(false);
//   const [showFixFieldsModal, setShowFixFieldsModal] = useState(false);
//   const [showCustomizeView, setShowCustomizeView] = useState(false);
//   const [selectedCandidateForEdit, setSelectedCandidateForEdit] = useState(null);
//   const [selectedCandidateForPreview, setSelectedCandidateForPreview] = useState(null);
//   const [hoveredRow, setHoveredRow] = useState(null);
//   const [jobs, setJobs] = useState([]);
//   const [accessDenied, setAccessDenied] = useState(false);
//   const [allColumns, setAllColumns] = useState([]);
//   const [columnsByCategory, setColumnsByCategory] = useState({});

//   const [visibleColumns, setVisibleColumns] = useState(() => {
//     const saved = localStorage.getItem('candidateViewColumns');
//     return saved ? JSON.parse(saved) : [
//       'applicationId', 'firstName', 'lastName', 'primaryEmail', 'primaryPhone',
//       'currentJobTitle', 'totalYearsOfExperience', 'status', 'createdAt'
//     ];
//   });

//   const [filters, setFilters] = useState({
//     status: null,
//     jobId: null,
//     experienceMin: '',
//     experienceMax: '',
//     noticePeriod: ''
//   });

//   const statusOptions = [
//     { value: 'Applied', label: 'Applied' },
//     { value: 'Screening', label: 'Screening' },
//     { value: 'Interview_Scheduled', label: 'Interview Scheduled' },
//     { value: 'Interview_Completed', label: 'Interview Completed' },
//     { value: 'Selected', label: 'Selected' },
//     { value: 'Rejected', label: 'Rejected' },
//     { value: 'Offered', label: 'Offered' },
//     { value: 'Joined', label: 'Joined' },
//     { value: 'On_Hold', label: 'On Hold' }
//   ];

//   // Helper function to categorize fields based on field name
//   const getCategoryForField = (fieldName) => {
//     const categories = {
//       'Basic Information': ['applicationId', 'organizationId', 'firstName', 'middleName', 'lastName', 'fullName', 'dateOfBirth', 'age', 'gender', 'nationality'],
//       'Contact Information': ['primaryEmail', 'primaryPhone', 'whatsappNumber', 'linkedInProfile', 'portfolioWebsite'],
//       'Location': ['city', 'state', 'province', 'region', 'postalCode', 'country', 'willingToRelocate'],
//       'Professional Information': ['currentJobTitle', 'currentCompany', 'currentJobStartDate', 'previousJobTitle', 'previousExperience', 'previousJobStartDate', 'totalYearsOfExperience', 'technicalSkills', 'softSkills'],
//       'Compensation': ['currentCTC', 'expectedCTC', 'salaryCurrency', 'salaryFrequency', 'noticePeriod'],
//       'Education': ['highestEducationLevel', 'fieldOfStudy', 'gpa', 'additionalDegrees', 'universityName'],
//       'Application Status': ['status', 'jobIds', 'clientIds', 'sourceOfApplication', 'resumeUrl', 'actualjoiningdate', 'screeningQuestionsByJob'],
//       'Consent & Verification': ['backgroundCheckConsent', 'drugTestConsent', 'rightToWorkConfirm', 'dataProcessingConsent', 'communicationsConsent', 'termsAndConditionsConsent', 'creditCheckConsent', 'employmentVerificationConsent', 'educationVerificationConsent']
//     };

//     for (const [category, fields] of Object.entries(categories)) {
//       if (fields.includes(fieldName)) {
//         return category;
//       }
//     }
//     return 'Other';
//   };

//   // Fetch field configuration from API
//   const fetchFieldConfiguration = async () => {
//     try {
//       // console.log('Fetching fields from API...');
//       const response = await candidatesAPI.getFields();
//       // console.log('Raw API Response:', response);
//       // console.log('Response data:', response.data);
      
//       let fields = response.data;
      
//       // Handle different response structures
//       if (!fields) {
//         console.error('No data in response');
//         setDefaultColumns();
//         return;
//       }

//       // If data is wrapped in another object
//       if (fields && typeof fields === 'object' && !Array.isArray(fields)) {
//         // console.log('Data is object, checking for nested fields...');
//         if (fields.fields) fields = fields.fields;
//         else if (fields.data) fields = fields.data;
//         else if (fields.content) fields = fields.content;
//         // console.log('After unwrapping:', fields);
//       }
      
//       if (!Array.isArray(fields)) {
//         console.error('Fields is not an array:', typeof fields, fields);
//         setDefaultColumns();
//         return;
//       }

//       if (fields.length === 0) {
//         console.warn('Fields array is empty');
//         setDefaultColumns();
//         return;
//       }

//       // console.log('Processing fields array with', fields.length, 'items');
      
//       // Transform API fields to column format
//       const columns = fields.map((field, index) => {
//         // console.log(`Processing field ${index}:`, field);
        
//         // Handle both string and object formats
//         let key, label, required, category, fieldType;
        
//         if (typeof field === 'string') {
//           // Field is just a string (field name)
//           key = field;
//           // Convert camelCase to Title Case
//           label = field
//             .replace(/([A-Z])/g, ' $1') // Add space before capital letters
//             .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
//             .trim();
//           required = ['applicationId', 'firstName', 'organizationId'].includes(field);
//           category = getCategoryForField(field);
//           fieldType = 'text';
//         } else {
//           // Field is an object
//           key = field.fieldName || field.name || field.key || field.id || `field_${index}`;
//           label = field.label || field.displayName || field.fieldLabel || 
//                  (typeof key === 'string' ? key.replace(/([A-Z])/g, ' $1').trim() : key);
//           required = field.required || field.mandatory || field.isRequired || false;
//           category = field.category || field.group || field.section || 'Other';
//           fieldType = field.fieldType || field.type || 'text';
//         }
        
//         return {
//           key: key,
//           label: label,
//           required: required,
//           category: category,
//           fieldType: fieldType
//         };
//       });

//       // console.log('Transformed columns:', columns);
      
//       if (columns.length === 0) {
//         console.error('No columns after transformation');
//         setDefaultColumns();
//         return;
//       }

//       setAllColumns(columns);

//       // Group columns by category
//       const grouped = columns.reduce((acc, column) => {
//         const category = column.category || 'Other';
//         if (!acc[category]) {
//           acc[category] = [];
//         }
//         acc[category].push(column);
//         return acc;
//       }, {});

//       // console.log('Grouped columns:', grouped);
//       // console.log('Number of categories:', Object.keys(grouped).length);
//       setColumnsByCategory(grouped);

//       // Update visible columns to include required fields
//       const requiredColumns = columns.filter(col => col.required).map(col => col.key);
//       console.log('Required columns:', requiredColumns);
      
//       const saved = localStorage.getItem('candidateViewColumns');
//       let finalVisibleColumns;
      
//       if (saved) {
//         try {
//           const savedColumns = JSON.parse(saved);
//           finalVisibleColumns = [...new Set([...requiredColumns, ...savedColumns])];
//         } catch (e) {
//           console.error('Error parsing saved columns:', e);
//           finalVisibleColumns = requiredColumns.length > 0 ? requiredColumns : columns.slice(0, 9).map(c => c.key);
//         }
//       } else {
//         // Default to first 9 columns or required columns
//         finalVisibleColumns = requiredColumns.length > 0 ? requiredColumns : columns.slice(0, 9).map(c => c.key);
//       }
      
//       // console.log('Final visible columns:', finalVisibleColumns);
//       setVisibleColumns(finalVisibleColumns);
      
//       // toast.success(`Loaded ${columns.length} columns from API`);
      
//     } catch (error) {
//       console.error('Error fetching field configuration:', error);
//       console.error('Error details:', error.response?.data || error.message);
//       toast.error('Failed to load field configuration. Using default fields.');
//       setDefaultColumns();
//     }
//   };

//   // Fallback default columns
//   const setDefaultColumns = () => {
//     const defaultColumns = [
//       { key: 'applicationId', label: 'Application ID', required: true, category: 'Basic Information' },
//       { key: 'firstName', label: 'First Name', required: true, category: 'Basic Information' },
//       { key: 'lastName', label: 'Last Name', category: 'Basic Information' },
//       { key: 'primaryEmail', label: 'Email', category: 'Contact Information' },
//       { key: 'primaryPhone', label: 'Phone', category: 'Contact Information' },
//       { key: 'currentJobTitle', label: 'Current Role', category: 'Professional Information' },
//       { key: 'currentCompany', label: 'Company', category: 'Professional Information' },
//       { key: 'totalYearsOfExperience', label: 'Experience', category: 'Professional Information' },
//       { key: 'currentCTC', label: 'Current CTC', category: 'Compensation' },
//       { key: 'expectedCTC', label: 'Expected CTC', category: 'Compensation' },
//       { key: 'noticePeriod', label: 'Notice Period', category: 'Professional Information' },
//       { key: 'status', label: 'Status', category: 'Application Status' },
//       { key: 'jobId', label: 'Job ID', category: 'Application Status' },
//       { key: 'city', label: 'City', category: 'Location' },
//       { key: 'state', label: 'State', category: 'Location' },
//       { key: 'country', label: 'Country', category: 'Location' },
//       { key: 'createdAt', label: 'Applied Date', category: 'Metadata' }
//     ];

//     setAllColumns(defaultColumns);

//     const grouped = defaultColumns.reduce((acc, column) => {
//       const category = column.category;
//       if (!acc[category]) {
//         acc[category] = [];
//       }
//       acc[category].push(column);
//       return acc;
//     }, {});

//     setColumnsByCategory(grouped);
//   };

//   // Fetch all candidates
//   const fetchCandidates = async () => {
//     setLoading(true);
//     setAccessDenied(false);
//     try {
//       const response = await candidatesAPI.getAllApplicationsByOrg();
//       // console.log(response.data);
//       let candidatesData = Array.isArray(response.data) ? response.data : response.data.content || [];
//       setCandidates(candidatesData);
//       setFilteredCandidates(candidatesData);
//     } catch (error) {
//       console.error('Error fetching candidates:', error);
      
//       if (error.response?.status === 403) {
//         setAccessDenied(true);
//         toast.error('Access Denied: Syncing permissions...');
//       } else if (error.response?.status === 401) {
//         toast.error('Session expired. Please login again.');
//       } else if (error.response?.status === 500) {
//         toast.error('Server error: Failed to fetch candidates. Please try again later.');
//       } else {
//         toast.error('Failed to fetch candidates: ' + (error.response?.data?.message || error.message));
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch all jobs for filter dropdown
//   const fetchJobs = async () => {
//     try {
//       const response = await jobsAPI.getAllJobs();
//       let jobsData = Array.isArray(response.data) ? response.data : response.data.content || [];
//       setJobs(jobsData);
//     } catch (error) {
//       // console.error('Error fetching jobs:', error);
//     }
//   };

//   useEffect(() => {
//     // console.log('Component mounted, fetching data...');
//     fetchFieldConfiguration();
//     fetchCandidates();
//     fetchJobs();
//   }, []);

//   // Debug: Log state changes
//   useEffect(() => {
//     // console.log('All Columns State:', allColumns);
//     // console.log('Columns By Category State:', columnsByCategory);
//     // console.log('Visible Columns State:', visibleColumns);
//   }, [allColumns, columnsByCategory, visibleColumns]);

//   // Apply filters and search
//   useEffect(() => {
//     let filtered = [...candidates];

//     // Filter by status
//     if (filters.status) {
//       filtered = filtered.filter(c => c.status === filters.status.value);
//     }

//     // Filter by job
//     if (filters.jobId) {
//       filtered = filtered.filter(c => c.jobId === filters.jobId.value);
//     }

//     // Filter by experience
//     if (filters.experienceMin) {
//       filtered = filtered.filter(c => {
//         const exp = parseInt(c.totalYearsOfExperience);
//         return !isNaN(exp) && exp >= parseInt(filters.experienceMin);
//       });
//     }

//     if (filters.experienceMax) {
//       filtered = filtered.filter(c => {
//         const exp = parseInt(c.totalYearsOfExperience);
//         return !isNaN(exp) && exp <= parseInt(filters.experienceMax);
//       });
//     }

//     // Search query
//     if (searchQuery) {
//       filtered = filtered.filter(c =>
//         c.firstName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         c.lastName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         c.primaryEmail?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         c.applicationId?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         c.primaryPhone?.includes(searchQuery)
//       );
//     }

//     setFilteredCandidates(filtered);
//   }, [filters, candidates, searchQuery]);

//   const handleFilterChange = (filterName, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [filterName]: value
//     }));
//   };

//   const clearAllFilters = () => {
//     setFilters({
//       status: null,
//       jobId: null,
//       experienceMin: '',
//       experienceMax: '',
//       noticePeriod: ''
//     });
//   };

//   const handleSelectAll = (e) => {
//     if (e.target.checked) {
//       setSelectedRows(filteredCandidates.map(c => c.id));
//     } else {
//       setSelectedRows([]);
//     }
//   };

//   const handleRowSelect = (id) => {
//     setSelectedRows(prev =>
//       prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]
//     );
//   };

//   const handleExport = () => {
//     const visibleCols = allColumns.filter(col => visibleColumns.includes(col.key));
//     exportCandidatesToExcel(filteredCandidates, visibleCols);
//   };

//   const handleDelete = async () => {
//     try {
//       for (const id of selectedRows) {
//         await candidatesAPI.deleteApplication(id);
//       }
//       toast.success('Candidate(s) deleted successfully');
//       setSelectedRows([]);
//       setShowDeleteModal(false);
//       fetchCandidates();
//     } catch (error) {
//       console.error('Error deleting candidates:', error);
//       toast.error('Failed to delete candidate(s)');
//     }
//   };

//   const handleEdit = (candidate) => {
//     setSelectedCandidateForEdit(candidate);
//     setShowEditModal(true);
//   };

//   const handlePreview = (candidate) => {
//     setSelectedCandidateForPreview(candidate);
//     setShowPreviewModal(true);
//   };

//   const handleDownloadTemplate = async () => {
//     try {
//       const response = await candidatesAPI.downloadTemplate();
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', 'candidate_template.xlsx');
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       toast.success('Template downloaded successfully');
//     } catch (error) {
//       console.error('Error downloading template:', error);
//       toast.error('Failed to download template');
//     }
//   };

//   const getStatusColor = (status) => {
//     const colors = {
//       'Applied': 'bg-blue-100 text-blue-800',
//       'Screening': 'bg-purple-100 text-purple-800',
//       'Interview_Scheduled': 'bg-yellow-100 text-yellow-800',
//       'Interview_Completed': 'bg-indigo-100 text-indigo-800',
//       'Selected': 'bg-green-100 text-green-800',
//       'Rejected': 'bg-red-100 text-red-800',
//       'Offered': 'bg-teal-100 text-teal-800',
//       'Joined': 'bg-emerald-100 text-emerald-800',
//       'On_Hold': 'bg-orange-100 text-orange-800'
//     };
//     return colors[status] || 'bg-gray-100 text-gray-800';
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString();
//   };

//   const handleColumnToggle = (columnKey) => {
//     const column = allColumns.find(col => col.key === columnKey);
//     if (column?.required) return;

//     setVisibleColumns(prev => {
//       const newColumns = prev.includes(columnKey)
//         ? prev.filter(key => key !== columnKey)
//         : [...prev, columnKey];
//       localStorage.setItem('candidateViewColumns', JSON.stringify(newColumns));
//       return newColumns;
//     });
//   };

//   const selectAllColumns = () => {
//     const allColumnKeys = allColumns.map(col => col.key);
//     setVisibleColumns(allColumnKeys);
//     localStorage.setItem('candidateViewColumns', JSON.stringify(allColumnKeys));
//   };

//   const resetToDefaultColumns = () => {
//     const defaultColumns = [
//       'applicationId', 'firstName', 'lastName', 'primaryEmail', 'primaryPhone',
//       'currentJobTitle', 'totalYearsOfExperience', 'status', 'createdAt'
//     ];
//     setVisibleColumns(defaultColumns);
//     localStorage.setItem('candidateViewColumns', JSON.stringify(defaultColumns));
//   };

//   const getColumnValue = (candidate, columnKey) => {
//     const value = candidate[columnKey];
    
//     // Handle null or undefined
//     if (value === null || value === undefined) {
//       return '-';
//     }
    
//     switch (columnKey) {
//       case 'status':
//         return (
//           <span className={`px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(value)}`}>
//             {value?.replace(/_/g, ' ') || '-'}
//           </span>
//         );
      
//       case 'createdAt':
//       case 'updatedAt':
//       case 'dateOfBirth':
//       case 'currentJobStartDate':
//       case 'previousJobStartDate':
//       case 'actualjoiningdate':
//         return formatDate(value);
      
//       case 'totalYearsOfExperience':
//       case 'previousExperience':
//         return value ? `${value} years` : '-';
      
//       case 'currentCTC':
//       case 'expectedCTC':
//         return value ? `₹${value.toLocaleString()}` : '-';
      
//       // Handle arrays
//       case 'jobIds':
//       case 'clientIds':
//         if (Array.isArray(value)) {
//           return value.length > 0 ? value.slice(0, 2).join(', ') + (value.length > 2 ? '...' : '') : '-';
//         }
//         return value || '-';
      
//       // Handle skill objects
//       case 'technicalSkills':
//       case 'softSkills':
//         if (Array.isArray(value)) {
//           const skillNames = value.map(skill => {
//             if (typeof skill === 'object' && skill !== null) {
//               return skill.skillName || skill.name || '';
//             }
//             return skill;
//           }).filter(Boolean);
//           return skillNames.length > 0 ? skillNames.slice(0, 3).join(', ') + (skillNames.length > 3 ? '...' : '') : '-';
//         }
//         if (typeof value === 'string') {
//           return value.length > 30 ? value.substring(0, 30) + '...' : value;
//         }
//         return '-';
      
//       case 'additionalDegrees':
//         if (Array.isArray(value)) {
//           return value.length > 0 ? `${value.length} degree${value.length > 1 ? 's' : ''}` : '-';
//         }
//         return value || '-';
      
//       // Handle boolean fields (consents)
//       case 'backgroundCheckConsent':
//       case 'drugTestConsent':
//       case 'rightToWorkConfirm':
//       case 'dataProcessingConsent':
//       case 'communicationsConsent':
//       case 'termsAndConditionsConsent':
//       case 'creditCheckConsent':
//       case 'employmentVerificationConsent':
//       case 'educationVerificationConsent':
//       case 'willingToRelocate':
//         if (typeof value === 'boolean') {
//           return (
//             <span className={`px-2 py-1 text-xs font-medium rounded-full ${
//               value ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
//             }`}>
//               {value ? 'Yes' : 'No'}
//             </span>
//           );
//         }
//         return '-';
      
//       case 'screeningQuestionsByJob':
//         if (typeof value === 'object' && value !== null) {
//           const jobCount = Object.keys(value).length;
//           return jobCount > 0 ? `${jobCount} job${jobCount > 1 ? 's' : ''}` : '-';
//         }
//         if (Array.isArray(value)) {
//           return value.length > 0 ? `${value.length} question${value.length > 1 ? 's' : ''}` : '-';
//         }
//         return '-';
      
//       // Handle objects
//       default:
//         if (typeof value === 'object' && value !== null) {
//           if (Array.isArray(value)) {
//             return value.length > 0 ? `${value.length} item${value.length > 1 ? 's' : ''}` : '-';
//           }
//           // For other objects, show a placeholder
//           return '[Object]';
//         }
        
//         // Handle strings
//         if (typeof value === 'string') {
//           return value.length > 50 ? value.substring(0, 50) + '...' : value;
//         }
        
//         // Handle numbers
//         if (typeof value === 'number') {
//           return value.toString();
//         }
        
//         return value || '-';
//     }
//   };

//   return (
//     <div className="flex flex-col h-screen bg-white">
//       {/* Header */}
//       <div className="flex-shrink-0 px-6 py-4 border-b bg-white">
//         <div className="flex items-center justify-between mb-4">
//           <div>
//             <h1 className="text-2xl font-bold text-gray-900">Candidates</h1>
//             <p className="text-sm text-gray-500 mt-1">
//               {filteredCandidates.length} candidate{filteredCandidates.length !== 1 ? 's' : ''}
//             </p>
//           </div>
//           <div className="flex items-center gap-3">
//             <button
//               onClick={() => setShowCustomizeView(true)}
//               className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 flex items-center gap-2 border border-gray-300"
//             >
//               <Columns size={16} />
//               Customize View
//             </button>
//             <button
//               onClick={() => setShowFixFieldsModal(true)}
//               className="px-4 py-2 text-sm border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 flex items-center gap-2"
//               title="Configure form fields"
//             >
//               <Settings size={16} />
//               Fix Fields
//             </button>
//             <button
//               onClick={handleDownloadTemplate}
//               className="px-4 py-2 text-sm border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 flex items-center gap-2"
//             >
//               <Download size={16} />
//               Template
//             </button>
//             <button
//               onClick={() => setShowImportModal(true)}
//               className="px-4 py-2 text-sm border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 flex items-center gap-2"
//             >
//               <Upload size={16} />
//               Import
//             </button>
//             <button
//               onClick={handleExport}
//               className="px-4 py-2 text-sm bg-green-600 text-white rounded-md hover:bg-green-700 flex items-center gap-2"
//             >
//               <Download size={16} />
//               Export
//             </button>
//             <button
//               onClick={() => setShowCreateModal(true)}
//               className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center gap-2"
//             >
//               <Plus size={16} />
//               Add Candidate
//             </button>
//           </div>
//         </div>

//         {/* Bulk Actions */}
//         {selectedRows.length > 0 && (
//           <div className="mb-4 p-3 bg-blue-50 rounded-md flex items-center justify-between">
//             <span className="text-sm text-blue-900 font-medium">
//               {selectedRows.length} selected
//             </span>
//             <div className="flex items-center gap-2">
//               {/* <button
//                 onClick={() => setShowShareModal(true)}
//                 className="px-3 py-1 text-sm text-blue-700 hover:bg-blue-100 rounded flex items-center gap-1"
//               >
//                 <Share2 size={14} />
//                 Share
//               </button> */}
//               <button
//                 onClick={() => setShowDeleteModal(true)}
//                 className="px-3 py-1 text-sm text-red-700 hover:bg-red-100 rounded"
//               >
//                 Delete
//               </button>
//               <button
//                 onClick={() => setSelectedRows([])}
//                 className="p-1 text-blue-700 hover:bg-blue-100 rounded"
//               >
//                 <X size={16} />
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Filters */}
//       <div className="p-4 border-b bg-gray-50">
//         <div className="flex items-center justify-between mb-4 gap-3 flex-wrap">
//           <div className="flex items-center gap-3 flex-wrap">
//             {/* Status Filter */}
//             <div className="w-48">
//               <select
//                 value={filters.status?.value || ''}
//                 onChange={(e) => {
//                   const selected = statusOptions.find(s => s.value === e.target.value);
//                   handleFilterChange('status', selected || null);
//                 }}
//                 className="px-3 py-2 border border-gray-300 rounded-md text-sm w-full"
//               >
//                 <option value="">All Status</option>
//                 {statusOptions.map(status => (
//                   <option key={status.value} value={status.value}>{status.label}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Job Filter */}
//             <div className="w-48">
//               <select
//                 value={filters.jobId?.value || ''}
//                 onChange={(e) => {
//                   const selected = jobs.find(j => j.jobCode === e.target.value);
//                   handleFilterChange('jobId', selected ? { value: selected.jobCode, label: selected.jobTitle } : null);
//                 }}
//                 className="px-3 py-2 border border-gray-300 rounded-md text-sm w-full"
//               >
//                 <option value="">All Jobs</option>
//                 {jobs.map(job => (
//                   <option key={job.id} value={job.jobCode}>{job.jobCode} - {job.jobTitle}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Experience Range */}
//             <div className="flex items-center gap-2">
//               <input
//                 type="number"
//                 placeholder="Min Exp"
//                 value={filters.experienceMin}
//                 onChange={(e) => handleFilterChange('experienceMin', e.target.value)}
//                 className="w-24 px-3 py-2 border border-gray-300 rounded-md text-sm"
//               />
//               <span className="text-gray-500">-</span>
//               <input
//                 type="number"
//                 placeholder="Max Exp"
//                 value={filters.experienceMax}
//                 onChange={(e) => handleFilterChange('experienceMax', e.target.value)}
//                 className="w-24 px-3 py-2 border border-gray-300 rounded-md text-sm"
//               />
//             </div>

//             {/* Clear Filters */}
//             {(filters.status || filters.jobId || filters.experienceMin || filters.experienceMax) && (
//               <button 
//                 onClick={clearAllFilters}
//                 className="px-3 py-2 text-sm text-red-600 hover:text-red-700 border border-red-300 rounded-md"
//               >
//                 Clear All
//               </button>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Search */}
//       <div className="flex items-center justify-between p-4 border-b gap-4">
//        <input
//   type="text"
//   placeholder="Search by name, email, phone or application ID..."
//   value={searchQuery}
//   onChange={(e) => setSearchQuery(e.target.value)}
//   className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
//   autoComplete="off"
//   autoCorrect="off"
//   autoCapitalize="off"
//   spellCheck="false"
// />
//         <div className="flex items-center gap-4 text-sm text-gray-600">
//           <span className="flex items-center gap-1">
//             <Columns size={14} />
//             <span>{visibleColumns.length} columns</span>
//           </span>
//           <button
//             onClick={() => setShowCustomizeView(true)}
//             className="flex items-center gap-1 text-blue-600 hover:text-blue-700"
//           >
//             <Columns size={14} />
//             <span>Customize</span>
//           </button>
//         </div>
//       </div>

//       {/* Table */}
//       <div className="flex-1 overflow-auto">
//         {accessDenied ? (
//           <div className="flex flex-col items-center justify-center h-64 text-gray-600">
//             <p className="text-lg font-semibold">Access Denied</p>
//             <p className="text-sm mt-2 text-center max-w-md">
//               You do not have permission to view candidates. Your permissions are being synced from the server.
//             </p>
//             <button
//               onClick={() => fetchCandidates()}
//               disabled={loading}
//               className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-gray-400"
//             >
//               {loading ? 'Retrying...' : 'Retry'}
//             </button>
//           </div>
//         ) : loading ? (
//           <div className="flex items-center justify-center h-64">
//             <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
//           </div>
//         ) : filteredCandidates.length === 0 ? (
//           <div className="flex flex-col items-center justify-center h-64 text-gray-500">
//             <p className="text-lg font-medium">No candidates found</p>
//             <p className="text-sm mt-1">Try adjusting your filters or add a new candidate</p>
//           </div>
//         ) : (
//           <table className="w-full text-sm">
//             <thead className="bg-gray-50 sticky top-0 z-10">
//               <tr>
//                 <th className="w-12 px-4 py-3 text-left">
//                   <input
//                     type="checkbox"
//                     checked={selectedRows.length === filteredCandidates.length && filteredCandidates.length > 0}
//                     onChange={handleSelectAll}
//                     className="rounded border-gray-300"
//                   />
//                 </th>
//                 {allColumns
//                   .filter(col => visibleColumns.includes(col.key))
//                   .map((column) => (
//                     <th
//                       key={column.key}
//                       className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
//                     >
//                       <div className="flex items-center gap-2">
//                         {column.label}
//                         <ArrowUpDown size={14} className="text-gray-400" />
//                       </div>
//                     </th>
//                   ))}
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Actions
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200">
//               {filteredCandidates.map((candidate) => (
//                 <tr
//                   key={candidate.id}
//                   onMouseEnter={() => setHoveredRow(candidate.id)}
//                   onMouseLeave={() => setHoveredRow(null)}
//                   className={`hover:bg-gray-50 ${
//                     selectedRows.includes(candidate.id) ? 'bg-blue-50' : ''
//                   }`}
//                 >
//                   <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
//                     <input
//                       type="checkbox"
//                       checked={selectedRows.includes(candidate.id)}
//                       onChange={() => handleRowSelect(candidate.id)}
//                       className="rounded border-gray-300"
//                     />
//                   </td>
//                   {allColumns
//                     .filter(col => visibleColumns.includes(col.key))
//                     .map((column) => (
//                       <td key={column.key} className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">
//                         {getColumnValue(candidate, column.key)}
//                       </td>
//                     ))}
//                   <td className="px-4 py-3 text-sm" onClick={(e) => e.stopPropagation()}>
//                     {hoveredRow === candidate.id && (
//                       <div className="flex items-center gap-2">
//                         <button
//                           onClick={() => handlePreview(candidate)}
//                           className="p-1 text-blue-600 hover:bg-blue-100 rounded"
//                           title="Preview candidate"
//                         >
//                           <Eye size={16} />
//                         </button>
//                         <button
//                           onClick={() => handleEdit(candidate)}
//                           className="p-1 text-blue-600 hover:bg-blue-100 rounded"
//                           title="Edit candidate"
//                         >
//                           <Edit2 size={16} />
//                         </button>
//                         <button
//                           onClick={() => {
//                             setSelectedRows([candidate.id]);
//                             setShowDeleteModal(true);
//                           }}
//                           className="p-1 text-red-600 hover:bg-red-100 rounded"
//                           title="Delete candidate"
//                         >
//                           <Trash2 size={16} />
//                         </button>
//                       </div>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </div>

//       {/* Customize View Modal */}
//       {showCustomizeView && (
//         <div className="fixed inset-0 z-50 flex justify-end bg-black/40 backdrop-blur-sm">
//           <div className="bg-white shadow-2xl w-full max-w-md h-full flex flex-col animate-slideInRight overflow-hidden">
//             {/* Header */}
//             <div className="flex items-center justify-between p-6 border-b flex-shrink-0 bg-white">
//               <div>
//                 <h2 className="text-xl font-bold text-gray-900">Customize View</h2>
//                 <p className="text-sm text-gray-500 mt-1">
//                   Select columns to display in table
//                 </p>
//                 <p className="text-xs text-gray-400 mt-1">
//                   {allColumns.length} total columns | {Object.keys(columnsByCategory).length} categories | {visibleColumns.length} visible
//                 </p>
//               </div>
//               <button
//                 onClick={() => setShowCustomizeView(false)}
//                 className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full"
//               >
//                 <X size={24} />
//               </button>
//             </div>

//             {/* Content */}
//             <div className="flex-1 overflow-y-auto p-6">
//               {allColumns.length === 0 ? (
//                 <div className="flex flex-col items-center justify-center h-64 text-gray-500">
//                   <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-4"></div>
//                   <p className="text-sm">Loading columns...</p>
//                   <p className="text-xs mt-2 text-gray-400">Check console for details</p>
//                   <button
//                     onClick={() => {
//                       console.log('Manual retry clicked');
//                       fetchFieldConfiguration();
//                     }}
//                     className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
//                   >
//                     Retry Now
//                   </button>
//                 </div>
//               ) : Object.keys(columnsByCategory).length === 0 ? (
//                 <div className="flex flex-col items-center justify-center h-64 text-gray-500">
//                   <p className="text-lg font-medium">No columns available</p>
//                   <p className="text-sm mt-1">Columns loaded: {allColumns.length}</p>
//                   <p className="text-xs mt-1 text-gray-400">Check console for details</p>
//                   <button
//                     onClick={() => {
//                       // console.log('Retry with default columns');
//                       setDefaultColumns();
//                     }}
//                     className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                   >
//                     Use Default Columns
//                   </button>
//                 </div>
//               ) : (
//                 <div className="space-y-6">
//                   {/* Quick Actions */}
//                   <div className="flex gap-3">
//                     <button
//                       onClick={selectAllColumns}
//                       className="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
//                     >
//                       Select All Columns
//                     </button>
//                     <button
//                       onClick={resetToDefaultColumns}
//                       className="px-4 py-2 text-sm bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
//                     >
//                       Reset to Default
//                     </button>
//                   </div>

//                   {/* Columns by Category */}
//                   {Object.entries(columnsByCategory).map(([category, columns]) => (
//                     <div key={category} className="space-y-3">
//                       <h3 className="text-lg font-semibold text-gray-900 border-b pb-2">
//                         {category}
//                       </h3>
//                       <div className="space-y-2">
//                         {columns.map((column) => (
//                           <label
//                             key={column.key}
//                             className={`flex items-center justify-between p-3 rounded-lg cursor-pointer transition-colors ${
//                               column.required
//                                 ? 'bg-blue-50 border border-blue-200'
//                                 : 'hover:bg-gray-50'
//                             }`}
//                           >
//                             <div className="flex items-center gap-3">
//                               <div>
//                                 <span className="font-medium text-gray-900">{column.label}</span>
//                                 {column.required && (
//                                   <span className="ml-2 text-xs text-blue-600 font-medium">Required</span>
//                                 )}
//                               </div>
//                             </div>
//                             <div className="flex items-center">
//                               {column.required ? (
//                                 <div className="w-5 h-5 rounded bg-blue-600 flex items-center justify-center">
//                                   <Check size={14} className="text-white" />
//                                 </div>
//                               ) : (
//                                 <input
//                                   type="checkbox"
//                                   checked={visibleColumns.includes(column.key)}
//                                   onChange={() => handleColumnToggle(column.key)}
//                                   className="w-5 h-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
//                                 />
//                               )}
//                             </div>
//                           </label>
//                         ))}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>

//             {/* Footer */}
//             <div className="flex gap-3 p-6 border-t bg-gray-50 flex-shrink-0">
//               <button
//                 onClick={() => setShowCustomizeView(false)}
//                 className="flex-1 px-6 py-3 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 font-medium"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={() => setShowCustomizeView(false)}
//                 className="flex-1 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700"
//               >
//                 Apply Changes
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Modals */}
//       {showCreateModal && (
//         <CreateCandidateModal
//           jobs={jobs}
//           onClose={() => setShowCreateModal(false)}
//           onCreate={() => {
//             setShowCreateModal(false);
//             fetchCandidates();
//           }}
//         />
//       )}

//       {showEditModal && selectedCandidateForEdit && (
//         <EditCandidateModal
//           candidate={selectedCandidateForEdit}
//           jobs={jobs}
//           onClose={() => {
//             setShowEditModal(false);
//             setSelectedCandidateForEdit(null);
//           }}
//           onSave={() => {
//             setShowEditModal(false);
//             setSelectedCandidateForEdit(null);
//             fetchCandidates();
//           }}
//         />
//       )}

//       {showPreviewModal && selectedCandidateForPreview && (
//         <CandidatePreview
//           candidate={selectedCandidateForPreview}
//           onClose={() => {
//             setShowPreviewModal(false);
//             setSelectedCandidateForPreview(null);
//           }}
//         />
//       )}

//       {showImportModal && (
//         <ImportCandidatesModal
//           jobs={jobs}
//           onClose={() => setShowImportModal(false)}
//           onImport={() => {
//             setShowImportModal(false);
//             fetchCandidates();
//           }}
//         />
//       )}

//       {/* {showShareModal && (
//         <ShareCandidatesModal
//           selectedCandidateIds={selectedRows}
//           onClose={() => setShowShareModal(false)}
//         />
//       )} */}

//       {showFixFieldsModal && (
//         <FixCandidateFieldsModal
//           onClose={() => setShowFixFieldsModal(false)}
//           onSave={() => {
//             setShowFixFieldsModal(false);
//             toast.success('Field configuration saved');
//             fetchFieldConfiguration();
//             fetchCandidates();
//           }}
//         />
//       )}

//       {showDeleteModal && (
//         <Delete
//           selectedCount={selectedRows.length}
//           onClose={() => setShowDeleteModal(false)}
//           onDeleteConfirm={handleDelete}
//           entityName="candidate"
//         />
//       )}
//     </div>
//   );
// };

// export default Candidates;

import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Plus, X, ArrowUpDown, Download, Upload, Eye, Edit2, Trash2, Settings, Columns, Check, Mail, Lock, UserCheck, Share2, Briefcase } from 'lucide-react';
import { IoLogoWhatsapp } from 'react-icons/io5';
import { candidatesAPI, jobsAPI, clientsAPI } from "../../services/api";
import { toast } from "react-toastify";
import { exportCandidatesToExcel } from "../../utils/ExportUtils";
import Delete from "../common/Delete";
import CreateCandidateModal from "./CreateCandidateModal";
import EditCandidateModal from "./EditCandidateModal";
import CandidatePreview from "./CandidatePreview";
import ImportCandidatesModal from "./ImportCandidatesModal";
import FixCandidateFieldsModal from "./FixCandidateFieldsModal";
import { getWhatsAppNumber, getWhatsAppNumberSource } from '../Templates/templateUtils';
import EmailTemplatePanel from '../Templates/EmailTemplatePanel';
import WhatsAppTemplatePanel from '../Templates/WhatsAppTemplatePanel';
import ShareCandidatesModal from './ShareCandidatesModal';
import CandidateRecommendation from './CandidateRecommendation';

const BRAND = "#1C4E6D";
const BRAND_DARK = "#153a4f";

const Candidates = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [candidates, setCandidates] = useState([]);
  const [filteredCandidates, setFilteredCandidates] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [pendingDeleteIds, setPendingDeleteIds] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [isRecommendFlow, setIsRecommendFlow] = useState(false);
  const [showFixFieldsModal, setShowFixFieldsModal] = useState(false);
  const [showCustomizeView, setShowCustomizeView] = useState(false);
  const [selectedCandidateForEdit, setSelectedCandidateForEdit] = useState(null);
  const [selectedCandidateForPreview, setSelectedCandidateForPreview] = useState(null);
  const [emailPanelCandidate, setEmailPanelCandidate] = useState(null);
  const [whatsappPanelCandidate, setWhatsappPanelCandidate] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [clients, setClients] = useState([]);
  const [accessDenied, setAccessDenied] = useState(false);
  const [allColumns, setAllColumns] = useState([]);
  const [columnsByCategory, setColumnsByCategory] = useState({});

  const [visibleColumns, setVisibleColumns] = useState(() => {
    const saved = localStorage.getItem('candidateViewColumns');
    return saved ? JSON.parse(saved).filter(k => k !== 'lastName') : [
      'applicationId', 'firstName', 'primaryEmail', 'primaryPhone',
      'currentJobTitle', 'totalYearsOfExperience', 'status', 'createdAt'
    ];
  });

  const [filters, setFilters] = useState({
    status: null,
    jobId: null,
    clientId: null,
    experienceMin: '',
    experienceMax: '',
    noticePeriod: ''
  });

  const statusOptions = [
    { value: 'Applied', label: 'Applied' },
    { value: 'Screening', label: 'Screening' },
    { value: 'Interview_Scheduled', label: 'Interview Scheduled' },
    { value: 'Interview_Completed', label: 'Interview Completed' },
    { value: 'Selected', label: 'Selected / Hired' },
    { value: 'Rejected', label: 'Rejected' },
    { value: 'Offered', label: 'Offered' },
    { value: 'Joined', label: 'Joined' },
    { value: 'On_Hold', label: 'On Hold' }
  ];

  const getCategoryForField = (fieldName) => {
    const categories = {
      'Basic Information': ['applicationId', 'organizationId', 'firstName', 'middleName', 'lastName', 'fullName', 'dateOfBirth', 'age', 'gender', 'nationality'],
      'Contact Information': ['primaryEmail', 'primaryPhone', 'whatsappNumber', 'linkedInProfile', 'portfolioWebsite'],
      'Location': ['city', 'state', 'province', 'region', 'postalCode', 'country', 'willingToRelocate'],
      'Professional Information': ['currentJobTitle', 'currentCompany', 'currentJobStartDate', 'previousJobTitle', 'previousExperience', 'previousJobStartDate', 'totalYearsOfExperience', 'technicalSkills', 'softSkills'],
      'Compensation': ['currentCTC', 'expectedCTC', 'salaryCurrency', 'salaryFrequency', 'noticePeriod'],
      'Education': ['highestEducationLevel', 'fieldOfStudy', 'gpa', 'additionalDegrees', 'universityName'],
      'Application Status': ['status', 'jobIds', 'clientIds', 'sourceOfApplication', 'resumeUrl', 'actualjoiningdate', 'screeningQuestionsByJob'],
      'Consent & Verification': ['backgroundCheckConsent', 'drugTestConsent', 'rightToWorkConfirm', 'dataProcessingConsent', 'communicationsConsent', 'termsAndConditionsConsent', 'creditCheckConsent', 'employmentVerificationConsent', 'educationVerificationConsent']
    };

    for (const [category, fields] of Object.entries(categories)) {
      if (fields.includes(fieldName)) {
        return category;
      }
    }
    return 'Other';
  };

  const fetchFieldConfiguration = async () => {
    try {
      const response = await candidatesAPI.getFields();
      let fields = response.data;

      if (!fields) {
        setDefaultColumns();
        return;
      }

      if (fields && typeof fields === 'object' && !Array.isArray(fields)) {
        if (fields.fields) fields = fields.fields;
        else if (fields.data) fields = fields.data;
        else if (fields.content) fields = fields.content;
      }

      if (!Array.isArray(fields)) {
        setDefaultColumns();
        return;
      }

      if (fields.length === 0) {
        setDefaultColumns();
        return;
      }

      const columns = fields.map((field, index) => {
        let key, label, required, category, fieldType;

        if (typeof field === 'string') {
          key = field;
          label = field
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, str => str.toUpperCase())
            .trim();
          required = ['applicationId', 'firstName', 'organizationId'].includes(field);
          category = getCategoryForField(field);
          fieldType = 'text';
        } else {
          key = field.fieldName || field.name || field.key || field.id || `field_${index}`;
          label = field.label || field.displayName || field.fieldLabel ||
            (typeof key === 'string' ? key.replace(/([A-Z])/g, ' $1').trim() : key);
          required = field.required || field.mandatory || field.isRequired || false;
          category = field.category || field.group || field.section || 'Other';
          fieldType = field.fieldType || field.type || 'text';
        }

        return { key, label, required, category, fieldType };
      }).filter(col => col.key !== 'lastName');

      if (columns.length === 0) {
        setDefaultColumns();
        return;
      }

      setAllColumns(columns);

      const grouped = columns.reduce((acc, column) => {
        const category = column.category || 'Other';
        if (!acc[category]) acc[category] = [];
        acc[category].push(column);
        return acc;
      }, {});

      setColumnsByCategory(grouped);

      const requiredColumns = columns.filter(col => col.required).map(col => col.key);
      const saved = localStorage.getItem('candidateViewColumns');
      let finalVisibleColumns;

      if (saved) {
        try {
          const savedColumns = JSON.parse(saved);
          finalVisibleColumns = [...new Set([...requiredColumns, ...savedColumns])];
        } catch (e) {
          finalVisibleColumns = requiredColumns.length > 0 ? requiredColumns : columns.slice(0, 9).map(c => c.key);
        }
      } else {
        finalVisibleColumns = requiredColumns.length > 0 ? requiredColumns : columns.slice(0, 9).map(c => c.key);
      }

      setVisibleColumns(finalVisibleColumns);
    } catch (error) {
      console.error('Error fetching field configuration:', error);
      toast.error('Failed to load field configuration. Using default fields.');
      setDefaultColumns();
    }
  };

  const setDefaultColumns = () => {
    const defaultColumns = [
      { key: 'applicationId', label: 'Application ID', required: true, category: 'Basic Information' },
      { key: 'firstName', label: 'Name', required: true, category: 'Basic Information' },
      { key: 'primaryEmail', label: 'Email', category: 'Contact Information' },
      { key: 'primaryPhone', label: 'Phone', category: 'Contact Information' },
      { key: 'currentJobTitle', label: 'Current Role', category: 'Professional Information' },
      { key: 'currentCompany', label: 'Company', category: 'Professional Information' },
      { key: 'totalYearsOfExperience', label: 'Experience', category: 'Professional Information' },
      { key: 'currentCTC', label: 'Current CTC', category: 'Compensation' },
      { key: 'expectedCTC', label: 'Expected CTC', category: 'Compensation' },
      { key: 'noticePeriod', label: 'Notice Period', category: 'Professional Information' },
      { key: 'status', label: 'Status', category: 'Application Status' },
      { key: 'jobId', label: 'Job ID', category: 'Application Status' },
      { key: 'city', label: 'City', category: 'Location' },
      { key: 'state', label: 'State', category: 'Location' },
      { key: 'country', label: 'Country', category: 'Location' },
      { key: 'createdAt', label: 'Applied Date', category: 'Metadata' }
    ];

    setAllColumns(defaultColumns);

    const grouped = defaultColumns.reduce((acc, column) => {
      const category = column.category;
      if (!acc[category]) acc[category] = [];
      acc[category].push(column);
      return acc;
    }, {});

    setColumnsByCategory(grouped);
  };

  const handleDownload = async (url, filename) => {
    if (!url) return;
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename || 'resume.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download failed:', error);
      window.open(url, '_blank');
    }
  };

  const fetchCandidates = async () => {
    setLoading(true);
    setAccessDenied(false);
    try {
      const response = await candidatesAPI.getAllApplicationsByOrg();
      let candidatesData = Array.isArray(response.data) ? response.data : response.data.content || [];
      setCandidates(candidatesData);
      setFilteredCandidates(candidatesData);
    } catch (error) {
      console.error('Error fetching candidates:', error);
      if (error.response?.status === 403) {
        setAccessDenied(true);
        toast.error('Access Denied: Syncing permissions...');
      } else if (error.response?.status === 401) {
        toast.error('Session expired. Please login again.');
      } else if (error.response?.status === 500) {
        toast.error('Server error: Failed to fetch candidates. Please try again later.');
      } else {
        toast.error('Failed to fetch candidates: ' + (error.response?.data?.message || error.message));
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchJobs = async () => {
    try {
      const response = await jobsAPI.getAllJobs();
      let jobsData = Array.isArray(response.data) ? response.data : response.data.content || [];
      setJobs(jobsData);
    } catch (error) {
      // silent
    }
  };

  const fetchClients = async () => {
    try {
      const response = await clientsAPI.getAllClients();
      let clientsData = Array.isArray(response.data) ? response.data : response.data.content || [];
      setClients(clientsData);
    } catch (error) {
      // silent
    }
  };

  useEffect(() => {
    fetchFieldConfiguration();
    fetchCandidates();
    fetchJobs();
    fetchClients();
  }, []);

  useEffect(() => {
    if (location.state?.openCreate) {
      setShowCreateModal(true);
    }
  }, [location.state]);

  useEffect(() => {
    const normalizePhoneQuery = (val) => {
      if (!val) return val;
      let d = val.replace(/\D/g, '');
      if (d.length === 12 && d.startsWith('91')) d = d.slice(2);
      if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
      return d;
    };
    let filtered = [...candidates];

    if (filters.status) {
      filtered = filtered.filter(c => c.status === filters.status.value);
    }

    if (filters.jobId) {
      filtered = filtered.filter(c => c.jobId === filters.jobId.value);
    }

    if (filters.clientId) {
      // Handle both clientId string or clientIds array
      filtered = filtered.filter(c =>
        c.clientId === filters.clientId.value ||
        (Array.isArray(c.clientIds) && c.clientIds.includes(filters.clientId.value))
      );
    }

    if (filters.experienceMin) {
      filtered = filtered.filter(c => {
        const exp = parseInt(c.totalYearsOfExperience);
        return !isNaN(exp) && exp >= parseInt(filters.experienceMin);
      });
    }

    if (filters.experienceMax) {
      filtered = filtered.filter(c => {
        const exp = parseInt(c.totalYearsOfExperience);
        return !isNaN(exp) && exp <= parseInt(filters.experienceMax);
      });
    }

    if (searchQuery) {
      filtered = filtered.filter(c =>
        c.firstName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        c.lastName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        c.primaryEmail?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        c.applicationId?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        c.primaryPhone?.includes(normalizePhoneQuery(searchQuery))
      );
    }

    setFilteredCandidates(filtered);
  }, [filters, candidates, searchQuery]);

  const handleFilterChange = (filterName, value) => {
    setFilters(prev => ({ ...prev, [filterName]: value }));
  };

  const clearAllFilters = () => {
    setFilters({
      status: null,
      jobId: null,
      clientId: null,
      experienceMin: '',
      experienceMax: '',
      noticePeriod: ''
    });
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(filteredCandidates.map(c => c.id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (id) => {
    setSelectedRows(prev =>
      prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]
    );
  };

  const handleExport = () => {
    const visibleCols = allColumns.filter(col => visibleColumns.includes(col.key));
    exportCandidatesToExcel(filteredCandidates, visibleCols);
  };

  // ✅ FIXED: uses pendingDeleteIds instead of selectedRows
  const handleDelete = async () => {
    try {
      for (const id of pendingDeleteIds) {
        await candidatesAPI.deleteApplication(id);
      }
      toast.success('Candidate(s) deleted successfully');
      setSelectedRows([]);
      setPendingDeleteIds([]);
      setShowDeleteModal(false);
      fetchCandidates();
    } catch (error) {
      console.error('Error deleting candidates:', error);
      toast.error('Failed to delete candidate(s)');
    }
  };

  const handleEdit = (candidate) => {
    setSelectedCandidateForEdit(candidate);
    setShowEditModal(true);
  };

  const handlePreview = (candidate) => {
    setSelectedCandidateForPreview(candidate);
    setShowPreviewModal(true);
  };

  const handleDownloadTemplate = async () => {
    try {
      const response = await candidatesAPI.downloadTemplate();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'candidate_template.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success('Template downloaded successfully');
    } catch (error) {
      console.error('Error downloading template:', error);
      toast.error('Failed to download template');
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      'Applied': 'bg-blue-100 text-blue-800',
      'Screening': 'bg-purple-100 text-purple-800',
      'Interview_Scheduled': 'bg-yellow-100 text-yellow-800',
      'Interview_Completed': 'bg-indigo-100 text-indigo-800',
      'Selected': 'bg-green-100 text-green-800',
      'Rejected': 'bg-red-100 text-red-800',
      'Offered': 'bg-teal-100 text-teal-800',
      'Joined': 'bg-emerald-100 text-emerald-800',
      'On_Hold': 'bg-orange-100 text-orange-800'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString();
  };

  const handleColumnToggle = (columnKey) => {
    const column = allColumns.find(col => col.key === columnKey);
    if (column?.required) return;

    setVisibleColumns(prev => {
      const newColumns = prev.includes(columnKey)
        ? prev.filter(key => key !== columnKey)
        : [...prev, columnKey];
      localStorage.setItem('candidateViewColumns', JSON.stringify(newColumns));
      return newColumns;
    });
  };

  const selectAllColumns = () => {
    const allColumnKeys = allColumns.map(col => col.key);
    setVisibleColumns(allColumnKeys);
    localStorage.setItem('candidateViewColumns', JSON.stringify(allColumnKeys));
  };

  const resetToDefaultColumns = () => {
    const defaultColumns = [
      'applicationId', 'firstName', 'primaryEmail', 'primaryPhone',
      'currentJobTitle', 'totalYearsOfExperience', 'status', 'createdAt'
    ];
    setVisibleColumns(defaultColumns);
    localStorage.setItem('candidateViewColumns', JSON.stringify(defaultColumns));
  };

  const getColumnValue = (candidate, columnKey) => {
    const value = candidate[columnKey];

    if (value === null || value === undefined) return '-';

    switch (columnKey) {
      case 'firstName': {
        const fName = candidate.firstName || '';
        const lName = candidate.lastName || '';
        const displayName = [fName, lName].filter(Boolean).join(' ');
        return (
          <div className="flex items-center gap-2">
            <div
              className="w-6 h-6 rounded flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
              style={{ backgroundColor: BRAND }}
            >
              {fName ? fName.charAt(0).toUpperCase() : '?'}
            </div>
            <button
              onClick={e => { e.stopPropagation(); navigate(`/candidates/${candidate.id}`); }}
              className="text-sm font-medium hover:underline cursor-pointer"
              style={{ color: BRAND }}
              onMouseEnter={e => e.currentTarget.style.color = BRAND_DARK}
              onMouseLeave={e => e.currentTarget.style.color = BRAND}
            >
              {displayName || <span className="text-gray-400 italic">Unnamed</span>}
            </button>
          </div>
        );
      }

      case 'status': {
        const s = (value || '').toLowerCase();
        const clientColor = s.includes('select') ? 'bg-green-100 text-green-800'
          : s.includes('reject') ? 'bg-red-100 text-red-800'
          : s.includes('shortlist') ? 'bg-blue-100 text-blue-800'
          : 'bg-gray-100 text-gray-800';
        return (
          <div className="flex items-center gap-1.5 flex-wrap">
            <span className={`px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(value)}`}>
              {value?.replace(/_/g, ' ') || '-'}
            </span>
            {candidate.statusSetBy === 'CLIENT' && (
              <span className={`px-2 py-1 text-xs font-medium rounded-full flex items-center gap-1 ${clientColor}`}>
                Client: {value}
                {candidate.statusLockedByClient === true && <Lock size={12} />}
              </span>
            )}
          </div>
        );
      }

      case 'createdAt':
      case 'updatedAt':
      case 'dateOfBirth':
      case 'currentJobStartDate':
      case 'previousJobStartDate':
      case 'actualjoiningdate':
        return formatDate(value);

      case 'totalYearsOfExperience':
      case 'previousExperience':
        return value ? `${value} years` : '-';

      case 'currentCTC':
      case 'expectedCTC':
        return value ? `₹${value.toLocaleString()}` : '-';

      case 'jobIds':
      case 'clientIds':
        if (Array.isArray(value)) {
          return value.length > 0 ? value.slice(0, 2).join(', ') + (value.length > 2 ? '...' : '') : '-';
        }
        return value || '-';

      case 'technicalSkills':
      case 'softSkills':
        if (Array.isArray(value)) {
          const skillNames = value.map(skill => {
            if (typeof skill === 'object' && skill !== null) {
              return skill.skillName || skill.name || '';
            }
            return skill;
          }).filter(Boolean);
          return skillNames.length > 0 ? skillNames.slice(0, 3).join(', ') + (skillNames.length > 3 ? '...' : '') : '-';
        }
        if (typeof value === 'string') {
          return value.length > 30 ? value.substring(0, 30) + '...' : value;
        }
        return '-';

      case 'additionalDegrees':
        if (Array.isArray(value)) {
          return value.length > 0 ? `${value.length} degree${value.length > 1 ? 's' : ''}` : '-';
        }
        return value || '-';

      case 'backgroundCheckConsent':
      case 'drugTestConsent':
      case 'rightToWorkConfirm':
      case 'dataProcessingConsent':
      case 'communicationsConsent':
      case 'termsAndConditionsConsent':
      case 'creditCheckConsent':
      case 'employmentVerificationConsent':
      case 'educationVerificationConsent':
      case 'willingToRelocate':
        if (typeof value === 'boolean') {
          return (
            <span className={`px-2 py-1 text-xs font-medium rounded-full ${value ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
              {value ? 'Yes' : 'No'}
            </span>
          );
        }
        return '-';

      case 'screeningQuestionsByJob':
        if (typeof value === 'object' && value !== null) {
          const jobCount = Object.keys(value).length;
          return jobCount > 0 ? `${jobCount} job${jobCount > 1 ? 's' : ''}` : '-';
        }
        if (Array.isArray(value)) {
          return value.length > 0 ? `${value.length} question${value.length > 1 ? 's' : ''}` : '-';
        }
        return '-';

      case 'primaryPhone': {
        const phone = candidate.primaryPhone || candidate.phone;
        if (!phone) return '-';
        const validWA = getWhatsAppNumber({ phone });
        return (
          <div className="flex items-center gap-1.5">
            <a href={`tel:${phone}`} className="text-blue-600 hover:underline">{phone}</a>
            <button onClick={e => { e.stopPropagation(); if (validWA) setWhatsappPanelCandidate(candidate); }}
              title={validWA ? 'Send WhatsApp' : 'Not a valid WhatsApp number'}
              disabled={!validWA}
              className={`opacity-40 group-hover:opacity-100 transition-opacity p-0.5 rounded ${validWA ? 'text-[#25D366] hover:bg-green-50 cursor-pointer' : 'text-gray-300 cursor-not-allowed'}`}>
              <IoLogoWhatsapp size={13} />
            </button>
          </div>
        );
      }

      case 'primaryEmail': {
        const email = candidate.primaryEmail || candidate.email;
        if (!email) return '-';
        return (
          <div className="flex items-center gap-1.5">
            <a href={`mailto:${email}`} className="text-blue-600 hover:underline">{email}</a>
            <button onClick={e => { e.stopPropagation(); setEmailPanelCandidate(candidate); }}
              title="Send email from template"
              className="opacity-40 group-hover:opacity-100 transition-opacity p-0.5 rounded text-blue-500 hover:text-blue-600 hover:bg-blue-50 cursor-pointer">
              <Mail size={13} />
            </button>
          </div>
        );
      }

      case 'resumeUrl': {
        if (!value || value === '-') return '-';
        return (
          <div className="flex items-center gap-2">
            <button 
              onClick={(e) => { e.stopPropagation(); window.open(value, '_blank'); }}
              className="p-1 text-blue-500 hover:bg-blue-50 rounded"
              title="View Resume"
            >
              <Eye size={14} />
            </button>
            <button 
              onClick={(e) => { e.stopPropagation(); handleDownload(value, `${candidate.firstName}_Resume.pdf`); }}
              className="p-1 text-emerald-500 hover:bg-emerald-50 rounded"
              title="Download Resume"
            >
              <Download size={14} />
            </button>
          </div>
        );
      }

      default:
        if (typeof value === 'object' && value !== null) {
          if (Array.isArray(value)) {
            return value.length > 0 ? `${value.length} item${value.length > 1 ? 's' : ''}` : '-';
          }
          return '[Object]';
        }
        if (typeof value === 'string') {
          return value.length > 50 ? value.substring(0, 50) + '...' : value;
        }
        if (typeof value === 'number') {
          return value.toString();
        }
        return value || '-';
    }
  };

  return (
    <div className="flex flex-col h-screen bg-white">
      {/* Header */}
      <div className="flex-shrink-0 px-6 py-4 border-b bg-white">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Candidates</h1>
            <p className="text-sm text-gray-500 mt-1">
              {filteredCandidates.length} candidate{filteredCandidates.length !== 1 ? 's' : ''}
            </p>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={handleDownloadTemplate}
              className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center gap-2"
            >
              <Download size={16} />
              Template
            </button>
            <button
              onClick={() => setShowImportModal(true)}
              className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center gap-2"
            >
              <Upload size={16} />
              Import
            </button>
            <button
              onClick={handleExport}
              className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center gap-2"
            >
              <Download size={16} />
              Export
            </button>
            {filters.status?.value === 'Rejected' && (
              <button
                onClick={() => {
                  if (selectedRows.length === 0) {
                    toast.error("Please select candidates first");
                    return;
                  }
                  setIsRecommendFlow(true);
                  setShowShareModal(true);
                }}
                className="px-4 py-2 text-sm bg-[#1C4E6D] text-white rounded-md hover:bg-[#0b1c48] flex items-center gap-2 transition-all shadow-md cursor-pointer"
                title="Recommend selected candidates to a new job/client"
              >
                <UserCheck size={16} />
                Recommend
              </button>
            )}


            <button
              onClick={() => setShowCreateModal(true)}
              className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center gap-2"
            >
              <Plus size={16} />
              Add Candidate
            </button>
          </div>
        </div>

        {/* Bulk Actions */}
        {selectedRows.length > 0 && (
          <div className="mb-4 p-3 bg-blue-50 rounded-md flex items-center justify-between">
            <span className="text-sm text-blue-900 font-medium">
              {selectedRows.length} selected
            </span>
            <div className="flex items-center gap-2">
              {filters.status?.value === 'Rejected' && (
                <button
                  onClick={() => {
                    setIsRecommendFlow(true);
                    setShowShareModal(true);
                  }}
                  className="px-4 py-1.5 text-sm bg-[#1C4E6D] text-white hover:bg-[#0b1c48] rounded flex items-center gap-2 font-medium"
                >
                  <UserCheck size={16} />
                  Recommend
                </button>
              )}

              <button
                onClick={() => setSelectedRows([])}
                className="p-1 text-blue-700 hover:bg-blue-100 rounded"
              >
                <X size={16} />
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Filters */}
      <div className="p-4 border-b bg-gray-50">
        <div className="flex items-center justify-between mb-4 gap-3 flex-wrap">
          <div className="flex items-center gap-3 flex-wrap">
            {/* Client Filter */}
            <div className="w-48">
              <select
                value={filters.clientId?.value || ''}
                onChange={(e) => {
                  const selected = clients.find(c => c.id === e.target.value);
                  handleFilterChange('clientId', selected ? { value: selected.id, label: selected.companyName || selected.clientName } : null);
                }}
                className="px-3 py-2 border border-gray-300 rounded-md text-sm w-full"
              >
                <option value="">All Clients</option>
                {clients.map(client => (
                  <option key={client.id} value={client.id}>{client.companyName || client.clientName}</option>
                ))}
              </select>
            </div>

            {/* Job Filter */}
            <div className="w-48">
              <select
                value={filters.jobId?.value || ''}
                onChange={(e) => {
                  const selected = jobs.find(j => j.jobCode === e.target.value);
                  handleFilterChange('jobId', selected ? { value: selected.jobCode, label: selected.jobTitle } : null);
                }}
                className="px-3 py-2 border border-gray-300 rounded-md text-sm w-full"
              >
                <option value="">All Jobs</option>
                {jobs
                  .filter(job => !filters.clientId || job.clientId === filters.clientId.value)
                  .map(job => (
                    <option key={job.id} value={job.jobCode}>{job.jobCode} - {job.jobTitle}</option>
                  ))
                }
              </select>
            </div>

            {/* Status Filter */}
            <div className="w-48">
              <select
                value={filters.status?.value || ''}
                onChange={(e) => {
                  const selected = statusOptions.find(s => s.value === e.target.value);
                  handleFilterChange('status', selected || null);
                }}
                className="px-3 py-2 border border-gray-300 rounded-md text-sm w-full"
              >
                <option value="">All Status</option>
                {statusOptions.map(status => (
                  <option key={status.value} value={status.value}>{status.label}</option>
                ))}
              </select>
            </div>

            {/* Experience Range */}
            <div className="flex items-center gap-2">
              <input
                type="number"
                placeholder="Min Exp"
                value={filters.experienceMin}
                onChange={(e) => handleFilterChange('experienceMin', e.target.value)}
                className="w-24 px-3 py-2 border border-gray-300 rounded-md text-sm"
              />
              <span className="text-gray-500">-</span>
              <input
                type="number"
                placeholder="Max Exp"
                value={filters.experienceMax}
                onChange={(e) => handleFilterChange('experienceMax', e.target.value)}
                className="w-24 px-3 py-2 border border-gray-300 rounded-md text-sm"
              />
            </div>

            {(filters.status || filters.jobId || filters.clientId || filters.experienceMin || filters.experienceMax) && (
              <button
                onClick={clearAllFilters}
                className="px-3 py-2 text-sm text-red-600 hover:text-red-700 border border-red-300 rounded-md"
              >
                Clear All
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Search */}
      <div className="flex items-center justify-between p-4 border-b gap-6 bg-white">
        <div className="relative flex-1 max-w-2xl">
          <Settings className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
          <input
            type="text"
            placeholder="Search by name, email, phone or application ID..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-10 pr-4 py-2.5 w-full border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all bg-gray-50/50 hover:bg-white focus:bg-white"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
          />
        </div>
        <div className="flex items-center gap-6 text-sm flex-shrink-0">
          <div className="flex items-center gap-2 text-gray-500 font-medium whitespace-nowrap">
            <Briefcase size={14} />
            <span>{visibleColumns.length} columns</span>
          </div>
          <div className="w-[1px] h-4 bg-gray-200" />
          <button
            onClick={() => setShowCustomizeView(true)}
            className="flex items-center gap-2 text-[#1C4E6D] hover:text-blue-700 font-bold transition-colors whitespace-nowrap"
          >
            <Columns size={18} />
            <span>Customize</span>
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="flex-1 overflow-auto">
        {accessDenied ? (
          <div className="flex flex-col items-center justify-center h-64 text-gray-600">
            <p className="text-lg font-semibold">Access Denied</p>
            <p className="text-sm mt-2 text-center max-w-md">
              You do not have permission to view candidates. Your permissions are being synced from the server.
            </p>
            <button
              onClick={() => fetchCandidates()}
              disabled={loading}
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-gray-400"
            >
              {loading ? 'Retrying...' : 'Retry'}
            </button>
          </div>
        ) : loading ? (
          <div className="flex items-center justify-center h-64">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        ) : filteredCandidates.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-64 text-gray-500">
            <p className="text-lg font-medium">No candidates found</p>
            <p className="text-sm mt-1">Try adjusting your filters or add a new candidate</p>
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 sticky top-0 z-10">
              <tr>
                <th className="w-12 px-4 py-3 text-left">
                  <input
                    type="checkbox"
                    checked={selectedRows.length === filteredCandidates.length && filteredCandidates.length > 0}
                    onChange={handleSelectAll}
                    className="rounded border-gray-300"
                  />
                </th>
                {allColumns
                  .filter(col => visibleColumns.includes(col.key))
                  .map((column) => (
                    <th
                      key={column.key}
                      className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
                    >
                      <div className="flex items-center gap-2">
                        {column.label}
                        <ArrowUpDown size={14} className="text-gray-400" />
                      </div>
                    </th>
                  ))}
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredCandidates.map((candidate) => (
                <tr
                  key={candidate.id}
                  onClick={() => navigate('/candidates/' + candidate.id)}
                  className={`group hover:bg-gray-50 cursor-pointer ${selectedRows.includes(candidate.id) ? 'bg-blue-50' : ''}`}
                >
                  <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(candidate.id)}
                      onChange={() => handleRowSelect(candidate.id)}
                      className="rounded border-gray-300"
                    />
                  </td>
                  {allColumns
                    .filter(col => visibleColumns.includes(col.key))
                    .map((column) => (
                      <td key={column.key} className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">
                        {getColumnValue(candidate, column.key)}
                      </td>
                    ))}
                  <td className="px-4 py-4 whitespace-nowrap sticky right-0 bg-white group-hover:bg-gray-50 transition-colors shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.04)]" onClick={e => e.stopPropagation()}>
                    <div className="flex items-center gap-1">
                      <button
                        onClick={() => handlePreview(candidate)}
                        className="p-1 text-blue-600 hover:bg-blue-100 rounded"
                        title="Preview candidate"
                      >
                        <Eye size={16} />
                      </button>
                      <button
                        onClick={() => handleEdit(candidate)}
                        className="p-1 text-blue-600 hover:bg-blue-100 rounded"
                        title="Edit candidate"
                      >
                        <Edit2 size={16} />
                      </button>
                      <button
                        onClick={() => {
                          setSelectedRows([candidate.id]);
                          setIsRecommendFlow(false);
                          setShowShareModal(true);
                        }}
                        className="p-1 text-blue-600 hover:bg-blue-100 rounded"
                        title="Share candidate"
                      >
                        <Mail size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Customize View Modal */}
      {showCustomizeView && (
        <div className="fixed inset-0 z-50 flex justify-end bg-black/40 backdrop-blur-sm">
          <div className="bg-white shadow-2xl w-full max-w-md h-full flex flex-col animate-slideInRight overflow-hidden">
            <div className="flex items-center justify-between p-6 border-b flex-shrink-0 bg-white">
              <div>
                <h2 className="text-xl font-bold text-gray-900">Customize View</h2>
                <p className="text-sm text-gray-500 mt-1">Select columns to display in table</p>
                <p className="text-xs text-gray-400 mt-1">
                  {allColumns.length} total columns | {Object.keys(columnsByCategory).length} categories | {visibleColumns.length} visible
                </p>
              </div>
              <button
                onClick={() => setShowCustomizeView(false)}
                className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full"
              >
                <X size={24} />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6">
              {allColumns.length === 0 ? (
                <div className="flex flex-col items-center justify-center h-64 text-gray-500">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-4"></div>
                  <p className="text-sm">Loading columns...</p>
                  <button
                    onClick={fetchFieldConfiguration}
                    className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
                  >
                    Retry Now
                  </button>
                </div>
              ) : Object.keys(columnsByCategory).length === 0 ? (
                <div className="flex flex-col items-center justify-center h-64 text-gray-500">
                  <p className="text-lg font-medium">No columns available</p>
                  <button
                    onClick={setDefaultColumns}
                    className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                  >
                    Use Default Columns
                  </button>
                </div>
              ) : (
                <div className="space-y-6">
                  <div className="flex gap-3">
                    <button
                      onClick={selectAllColumns}
                      className="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                      Select All Columns
                    </button>
                    <button
                      onClick={resetToDefaultColumns}
                      className="px-4 py-2 text-sm bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                    >
                      Reset to Default
                    </button>
                  </div>

                  {Object.entries(columnsByCategory).map(([category, columns]) => (
                    <div key={category} className="space-y-3">
                      <h3 className="text-lg font-semibold text-gray-900 border-b pb-2">{category}</h3>
                      <div className="space-y-2">
                        {columns.map((column) => (
                          <label
                            key={column.key}
                            className={`flex items-center justify-between p-3 rounded-lg cursor-pointer transition-colors ${
                              column.required ? 'bg-blue-50 border border-blue-200' : 'hover:bg-gray-50'
                            }`}
                          >
                            <div className="flex items-center gap-3">
                              <div>
                                <span className="font-medium text-gray-900">{column.label}</span>
                                {column.required && (
                                  <span className="ml-2 text-xs text-blue-600 font-medium">Required</span>
                                )}
                              </div>
                            </div>
                            <div className="flex items-center">
                              {column.required ? (
                                <div className="w-5 h-5 rounded bg-blue-600 flex items-center justify-center">
                                  <Check size={14} className="text-white" />
                                </div>
                              ) : (
                                <input
                                  type="checkbox"
                                  checked={visibleColumns.includes(column.key)}
                                  onChange={() => handleColumnToggle(column.key)}
                                  className="w-5 h-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                />
                              )}
                            </div>
                          </label>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="flex gap-3 p-6 border-t bg-gray-50 flex-shrink-0">
              <button
                onClick={() => setShowCustomizeView(false)}
                className="flex-1 px-6 py-3 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 font-medium"
              >
                Cancel
              </button>
              <button
                onClick={() => setShowCustomizeView(false)}
                className="flex-1 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700"
              >
                Apply Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modals */}
      {showCreateModal && (
        <CreateCandidateModal
          jobs={jobs}
          onClose={() => setShowCreateModal(false)}
          onCreate={() => {
            setShowCreateModal(false);
            fetchCandidates();
          }}
        />
      )}

      {showEditModal && selectedCandidateForEdit && (
        <EditCandidateModal
          candidate={selectedCandidateForEdit}
          jobs={jobs}
          onClose={() => {
            setShowEditModal(false);
            setSelectedCandidateForEdit(null);
          }}
          onSave={() => {
            setShowEditModal(false);
            setSelectedCandidateForEdit(null);
            fetchCandidates();
          }}
        />
      )}

      {showPreviewModal && selectedCandidateForPreview && (
        <CandidatePreview
          candidate={selectedCandidateForPreview}
          onClose={() => {
            setShowPreviewModal(false);
            setSelectedCandidateForPreview(null);
          }}
        />
      )}

      {showImportModal && (
        <ImportCandidatesModal
          jobs={jobs}
          onClose={() => setShowImportModal(false)}
          onImport={() => {
            setShowImportModal(false);
            fetchCandidates();
          }}
        />
      )}

      {showFixFieldsModal && (
        <FixCandidateFieldsModal
          onClose={() => setShowFixFieldsModal(false)}
          onSave={() => {
            setShowFixFieldsModal(false);
            toast.success('Field configuration saved');
            fetchFieldConfiguration();
            fetchCandidates();
          }}
        />
      )}

      {showShareModal && (
        <ShareCandidatesModal
          selectedCandidateIds={selectedRows}
          isRecommendFlow={isRecommendFlow}
          onClose={() => {
            setShowShareModal(false);
            setIsRecommendFlow(false);
            setSelectedRows([]);
          }}
        />
      )}

      {showDeleteModal && (
        <Delete
          selectedCount={pendingDeleteIds.length}
          onClose={() => {
            setShowDeleteModal(false);
            setPendingDeleteIds([]);
          }}
          onDeleteConfirm={handleDelete}
          entityName="candidate"
        />
      )}

      <EmailTemplatePanel
        isOpen={Boolean(emailPanelCandidate)}
        onClose={() => setEmailPanelCandidate(null)}
        module="ATS"
        context={emailPanelCandidate ? {
          candidateName: `${emailPanelCandidate.firstName || ''} ${emailPanelCandidate.lastName || ''}`.trim(),
          jobRole: emailPanelCandidate.currentJobTitle || '',
          senderName: localStorage.getItem('email') || '',
          agencyName: localStorage.getItem('organizationName') || '',
        } : {}}
        recipient={emailPanelCandidate ? {
          email: emailPanelCandidate.primaryEmail || emailPanelCandidate.email,
          name: `${emailPanelCandidate.firstName || ''} ${emailPanelCandidate.lastName || ''}`.trim(),
        } : null}
      />
      <WhatsAppTemplatePanel
        isOpen={Boolean(whatsappPanelCandidate)}
        onClose={() => setWhatsappPanelCandidate(null)}
        module="ATS"
        context={whatsappPanelCandidate ? {
          candidateName: `${whatsappPanelCandidate.firstName || ''} ${whatsappPanelCandidate.lastName || ''}`.trim(),
          jobRole: whatsappPanelCandidate.currentJobTitle || '',
          senderName: localStorage.getItem('email') || '',
          agencyName: localStorage.getItem('organizationName') || '',
        } : {}}
        recipient={whatsappPanelCandidate ? {
          phone: getWhatsAppNumber({ phone: whatsappPanelCandidate.primaryPhone || whatsappPanelCandidate.phone }),
          phoneSource: 'phone',
          name: `${whatsappPanelCandidate.firstName || ''} ${whatsappPanelCandidate.lastName || ''}`.trim(),
        } : null}
      />

    </div>

  );
};

export default Candidates;